
	import {
		Component,
		Model,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	
	import Dialog from '@/components/dialog.vue';
	import PickerDate from '@/components/picker-date.vue';
	import PageFooter from '@/components/page-footer.vue';
	
	import {
		customerOrderDistributedDetail
	} from '@/api/statistic'
	import {
		nextDay
	} from "@/utils"

	@Component({
		name: 'detail-dialog',
		components: {
			'slz-dialog': Dialog,
			PickerDate,
			PageFooter
		}
	})
	export default class DetailDialog extends Vue {
		@Model('change') isShow!: boolean;
		@Prop({}) private memberInfo!: any;
		@Prop(String) private time!:string;
		private showDialog = false;
		
		private defaultAvatar = 'https://cdn2024.routuan.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png'
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private keywords = '';
		private filterTime = '';
		

		@Watch('isShow')
		private onChangeShow(val: boolean) {
			this.showDialog = val;
			if (val) {
				this.filterTime = this.time;
				this.getList();
			}
		}
		
		private handleClose() {
			this.keywords = ''
			this.filterTime = ''
			this.pageNo = 1
			this.$emit('change', false);
		}
		
		private changePage(e) {
			this.pageNo = +e;
			this.getList();
		}
		
		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}
		
		private clearSearch() {
			this.pageNo = 1;
			this.keywords = '';
			this.filterTime = this.time;
			this.getList();
		}
		
		private async getList() {
			let params: any = {
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
				MemberId: this.memberInfo.MemberId,
				Keywords: this.keywords,
				StartTime:'',
				EndTime:'',
			}

			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				params.StartTime = dt[0];
				if (dt[1]){
					params.EndTime = nextDay(dt[1],1);
				}else{
					params.EndTime = '';
				}
			}
			
			try {
				const res: any = await customerOrderDistributedDetail(params);
				this.list = res.Result.Results;
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			}
		}
		
	}
